export function maxQuestionReachedMessage(
  maxQuestions: number | string
): string {
  return `You have reached the limit of ${maxQuestions} questions. Please remove one question to add another.`;
}
